import { createContext } from '@chakra-ui/react-utils';
import { type UseRadioGroupReturn } from '@chakra-ui/react-v2';

interface SegmentControlContext {
  getRadioProps: UseRadioGroupReturn['getRadioProps'];
  isDisabled: boolean;
}

const [SegmentControlProvider, useSegmentControlContext] =
  createContext<SegmentControlContext>({
    name: 'SegmentControlContext',
    errorMessage:
      'useSegmentControlContext: `context` is undefined. Seems you used a SegmentControl sub-component outside of a SegmentControl wrapping box.',
  });

export { SegmentControlProvider, useSegmentControlContext };
